module.exports = __webpack_public_path__ + "img/education.40d52ecf.jpg";